import React from "react";
import axios from 'axios';
import { Player }      from '@lottiefiles/react-lottie-player';
import { config }      from '../config/index';
import { Routes }      from '../navigation';
import { StringUtils, StyleUtils, CareOptions } from '../utils';
import { getItem } from '../Storage';
import { Button } from '../components';
import { ChatMessage } from '../containers';
import '../css/salient.css';
import '../css/chat.css';
import ConsultationController from '../controllers/consultationController';
import UtilitiesController    from '../controllers/utilitiesController';

export default class Chat extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pulled_messages: false,
      text: '',
      messages: [],
      loading_attachment_button: false,
      socket_bubble_on: false,
      bubble_seconds: 0,
      time_elapsed: 0,
      display_type_bubble: false,
      send_error: ''
    };

    this.socket = null;
    this.consultation_socket = null;
    this.input_ref = React.createRef();
    this.touch_primary = null;
  }

  socket_connect(care_consultation_id) {
    return UtilitiesController.getSocket({ name: `consultation_${care_consultation_id}`, query: 'consultation_id=' + care_consultation_id })
  }

  consultation_socket_connect(care_consultation_id) {
    return UtilitiesController.getSocket({ name: `consultation_${care_consultation_id}`, query: 'notification=' + care_consultation_id, notification: true })
  }

  connect_sockets = (care_consultation_id) => {

    if (!this.consultation_socket) {
      this.consultation_socket = this.consultation_socket_connect(care_consultation_id);
    }

    if (!this.socket) {
      this.socket = this.socket_connect(care_consultation_id);
    }

    this.consultation_socket.on('care_consultation_updated', async () => {
      if (this.props.care_consultation_update_action) {
        this.props.care_consultation_update_action();
      }
    });

    this.socket.on('care_chat_message', async (msg) => {
      this.get_care_consultation_messages(this.state.care_consultation_id);
    });

    this.socket.on('typing_bubble', (bubble_data) => {
      this.toggle_chat_bubble(bubble_data);
    });

  }

  componentDidMount = () => {
    let second_timer         = setInterval(this._onEverySecond, 1000);
    let care_consultation_id = getItem('care_consultation_id');
    this.get_care_consultation_messages(care_consultation_id);
    this.connect_sockets(care_consultation_id);
    this.setState({ care_consultation_id: care_consultation_id, second_timer: second_timer });
  }

  componentDidUpdate = () => {
    let care_consultation_id = getItem('care_consultation_id');
    if (care_consultation_id && !this.state.pulled_messages) {
      this.get_care_consultation_messages(care_consultation_id);
      this.setState({ pulled_messages: true });
    }
  }

  componentWillUnmout = () => {
    clearInterval(this.state.second_timer);
  }

  render_home_button = () => {
    let care_consultation = this.props.care_consultation;
    let partner           = care_consultation && care_consultation.partner ? care_consultation.partner : {};
    let is_home_enabled   = CareOptions.should_show_home(partner);

    if (!is_home_enabled) {
      return null;
    }
    
    return <div className='chat-home-btn sln-pressable'
                onClick={ () => {
                  let partner      = getItem('partner');
                  let partner_code = partner && partner.code ? partner.code : '';
                  this.props.navigate(Routes.HOME + partner_code)
                }}>
      <span className='fas fa-home' />
      <span>Home</span>
    </div>
  }

  render_top_section = () => {
    let provider      = this.props.care_consultation && this.props.care_consultation.provider ? this.props.care_consultation.provider : null;
    let provider_name = provider ? StringUtils.displayName(provider) : 'Provider';
    let image_url     = provider && provider.photo_url ? provider.photo_url : '';
    let initial       = provider_name ? provider_name.charAt(0).toUpperCase() : '';
    return <div className='chat-header'>
      <div className='chat-header-left'>
        <div className='sln-avatar chat-header-avatar'>
          { image_url ? <img src={ image_url } alt='' />
                      : ( initial ? <span>{ initial }</span> : <span className='fas fa-user-alt' /> ) }
        </div>
        <div className='chat-header-meta'>
          <span className='chat-header-name'>{ provider_name }</span>
          <span className='chat-header-status'><span className='chat-header-status-dot' />Care team</span>
        </div>
      </div>
      { this.render_home_button() }
    </div>
  }

  render_chat_section = () => {
    let messages = this.get_appended_messages();

    if (this.state.display_type_bubble) {
      messages = [ { type: 'BUBBLE' }, ...messages ];
    }

    let message_rows = messages.map((message, i) => {
      return <ChatMessage message={ message } key={i} />
    }).filter((row) => { return row });

    return <div className='chat-thread'>
      <div className='chat-thread-spacer' />
      { message_rows }
      <div className='chat-thread-spacer' />
    </div>
  }

  render_attachment_preview = () => {
    if (!this.state.file) {
      return null;
    }

    let not_supported   = <div className='chat-attach-preview'>
                            <span style={{ fontSize: 13, color: '#94a3b8', textAlign: 'center' }}>The format for this file is not supported.</span>
                          </div>
    let image_component = <div className='chat-attach-preview'>
                            <img className='chat-attach-img' alt='Message Attachment' src={this.state.file} />
                          </div>
    let video_component = <div className='chat-attach-preview'>
                            <video className='chat-attach-video' controls>
                              <source src={this.state.file} type="video/mp4" />
                              Sorry, your browser doesn't support this video format.
                            </video>
                          </div>
    let pdf_component   = <div className='chat-attach-preview'>
                            <div className='chat-pdf'>
                              <span className='fas fa-file-pdf chat-pdf-icon' />
                              <span className='chat-pdf-name'>{ this.state.pdf_name }</span>
                            </div>
                          </div>

    return <div className='chat-attach-modal'>
      <div />

      { !this.state.attachment_type            ? not_supported   : null }
      { this.state.attachment_type === 'IMAGE' ? image_component : null }
      { this.state.attachment_type === 'VIDEO' ? video_component : null }
      { this.state.attachment_type === 'PDF'   ? pdf_component   : null }

      <div className='chat-attach-actions'>
          <Button title='Cancel'
                  grey={true}
                  style={{ height: 50, flex: 1 }}
                  titleStyle={{ fontSize: 16 }}
                  onClick={ () => {
                    if (this.state.loading_attachment_button) {
                      return;
                    }
                    this.setState({ file: null, to_upload: null, attachment_type: '', pdf_name: '' });
                  }}/>
          <Button title='Send'
                  style={{ height: 50, flex: 1 }}
                  titleStyle={{ fontSize: 16 }}
                  loading={this.state.loading_attachment_button}
                  onClick={ () => {
                    this.upload_attachment();
                    this.setState({ loading_attachment_button: true });
                  }}/>
      </div>

    </div>
  }

  adjust_input_height = () => {
    let el = this.input_ref.current;
    if (!el) { return; }
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 150) + 'px';
  }

  // Enter-to-send is a hardware-keyboard convention. On touch-primary devices
  // (phones, tablets) the on-screen keyboard's return key must keep inserting a
  // newline, so Enter only submits when the primary pointer is fine (mouse/trackpad).
  is_touch_primary_device = () => {
    if (this.touch_primary === null) {
      let coarse = false;
      try {
        coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches ? true : false;
      } catch (err) {
        coarse = false;
      }
      this.touch_primary = coarse;
    }
    return this.touch_primary;
  }

  should_send_on_enter = (event) => {
    let native_event = event && event.nativeEvent ? event.nativeEvent : {};
    let is_composing = native_event.isComposing === true || event.keyCode === 229;   // IME composition in progress
    if (event.key !== 'Enter' || event.shiftKey || is_composing) { return false; }
    return !this.is_touch_primary_device();
  }

  // Turn an API failure into a line the pet parent can act on. Session expiry
  // and other human-readable app errors are shown as-is; transport/validation
  // noise collapses to a generic retry prompt.
  get_send_error_text = (response) => {
    let error_text   = response && typeof response.error === 'string' ? response.error.trim() : '';
    let is_technical = !error_text || error_text.length > 140 || /fetch|network|json|undefined|verify all inputs/i.test(error_text);
    if (is_technical) { return 'Your message was not sent. Please check your connection and tap send again.'; }
    return 'Your message was not sent. ' + error_text;
  }

  send_text_message = async () => {
    if (this.state.loading_send_button) { return; }
    if (!this.state.text || !this.state.text.trim()) { return; }

    // The id captured at mount can be empty when the chat was opened by code and
    // the lookup finished after Chat mounted; a message posted without an id is
    // rejected by the API, so fall back to the stored id before giving up.
    let consultation_id = this.state.care_consultation_id || getItem('care_consultation_id') || '';

    if (!consultation_id) {
      this.setState({ send_error: 'The chat is still loading. Please try again in a moment.' });
      return;
    }

    this.setState({ loading_send_button: true, send_error: '' });

    let message_data = {
      content: { text: this.state.text },
      consultation_id: consultation_id,
      type: 'TEXT'
    }

    let send_msg_res = await ConsultationController.sendCareConsultationMessage(message_data);
    let is_success   = send_msg_res && send_msg_res.success ? true : false;
    let send_error   = is_success ? '' : this.get_send_error_text(send_msg_res);

    if (is_success) {
      this.get_care_consultation_messages(consultation_id);
    } else {
      this.refresh_consultation_after_failed_send();
    }

    this.setState({ loading_send_button: false, text: is_success ? '' : this.state.text, send_error: send_error }, () => { this.adjust_input_height(); });
  }

  // A closed consultation refuses client messages. Re-read it so the screen moves to its
  // completed state instead of leaving the composer open.
  refresh_consultation_after_failed_send = () => {
    if (this.props.care_consultation_update_action) {
      this.props.care_consultation_update_action();
    }
  }

  render_input_section = () => {
    let is_resolved = this.props.is_resolved === true ? true : false;

    if (is_resolved) {
      return <div className='chat-resolved'>
        <span className='fas fa-check-circle chat-resolved-icon' />
        <span className='chat-resolved-text'>Consultation Completed</span>
      </div>
    }

    let has_text = this.state.text && this.state.text.trim().length > 0 ? true : false;

    return <div className='chat-composer'>
      { this.state.send_error ? <div className='chat-send-error' role='alert'>
                                  <span className='fas fa-exclamation-circle' />
                                  <span>{ this.state.send_error }</span>
                                </div> : null }
      <div className='chat-bar'>
        <textarea className='chat-input'
                  ref={ this.input_ref }
                  rows={1}
                  value={this.state.text}
                  placeholder='Write a message'
                  onChange={ (event) => {
                    let user_id              = getItem('user_id');
                    let care_consultation_id = getItem('care_consultation_id');

                    if (user_id && care_consultation_id) {
                      this.socket.emit('typing_bubble', { typer_id: user_id, consultation_id: care_consultation_id });
                    }
                    this.setState({ text: event.target.value, send_error: '' });
                    this.adjust_input_height();
                  }}
                  onKeyDown={ (event) => {
                    if (this.should_send_on_enter(event)) {
                      event.preventDefault();
                      this.send_text_message();
                    }
                  }}/>
        <div className='chat-actions'>
          <div className={ 'chat-send ' + (has_text ? 'sln-pressable' : 'is-disabled') }
               onClick={ () => { if (has_text) { this.send_text_message(); } }}>
            { this.state.loading_send_button ? <Player autoplay loop src={ require('../animations/white-spinner.json') } style={{ height: '20px', width: '20px' }} />
                                             : <span className='fas fa-arrow-up' /> }
          </div>
          <input className='chat-file-input'
                 type='file'
                 id='file-upload'
                 onChange={ (event) => {
                   this.setState({ loading_attachment_button: true });

                   this.handle_file_upload(event);

                   this.setState({ loading_attachment_button: false });
                 }}
                />
          <label className='chat-attach sln-pressable' htmlFor='file-upload'>
            <span className='fas fa-paperclip' />
          </label>
        </div>
      </div>
    </div>
  }

  render() {
    let root_style = {
      '--ch-accent':      StyleUtils.get_header_color(),
      '--ch-accent-text': StyleUtils.get_header_text_color_auto(),
      '--ch-button':      StyleUtils.get_button_color(),
      '--ch-button-text': StyleUtils.get_button_text_color_auto(),
      '--ch-primary':     StyleUtils.get_primary_color(),
    };
    return (
      <div className='chat-root' style={root_style}>
        { this.render_top_section()   }
        { this.render_chat_section()  }
        { this.render_input_section() }
        { this.render_attachment_preview() }
      </div>
    );
  }

  handle_file_upload = (event) => {
    let file  = event.target.files[0];
    let files = event.target.files;

    let media_type = '';
    let pdf_name   = '';

    if (file && file.type === 'image/jpeg' || file.type === 'image/png') {
      media_type = 'IMAGE'
    }

    if (file && file.type === 'video/mp4' || file.type === 'video/3gpp' || file.type === 'video/quicktime' || file.type === 'video/3gpp') {
      media_type = 'VIDEO'
    }

    if (file && file.type === 'application/pdf') {
      media_type = 'PDF'
      pdf_name   = file.name || '';
    }

    let reader = new FileReader();

    reader.onloadend = () => {
      this.setState({ file: reader.result, to_upload: files, attachment_type: media_type, pdf_name: pdf_name });
    }

    reader.readAsDataURL(file);
  }

  upload_attachment = () => {
    let token         = getItem('token');
    let random_id     = getItem('user_id');

    let body = new FormData();
        body.append("file", this.state.to_upload[0])

    let request_url    = `${config.apiURL}/v3/api/file/chat`;
    let request_config = { headers: { 'authorization': token, 'content-type': 'multipart/form-data' } };

    axios.post(request_url, body, request_config).then((response) => {
      let response_data = response.data;
      let url           = response_data && response_data.message && response_data.message.Location ? response_data.message.Location : '';

      if (url) {
        this.send_media_message(url);
      } else {
        this.setState({ ...this.state, loading_attachment_button: false, send_error: 'Your attachment was not sent. Please try again.' })
      }
    }).catch((error) => {
      console.log(error)
      this.setState({ ...this.state, loading_attachment_button: false, send_error: 'Your attachment was not sent. Please check your connection and try again.' });
    });
  }

  send_media_message = async (url) => {
    let consultation_id = getItem('care_consultation_id');
    let selected_media  = this.state.attachment_type;
    let media_type      = selected_media === 'VIDEO' ? 'VIDEO' : '';
        media_type      = selected_media === 'IMAGE' ? 'IMAGE' : media_type;
        media_type      = selected_media === 'PDF'   ? 'PDF'   : media_type;

    let message_data    = { content: { url: url, }, consultation_id: consultation_id, type: media_type }

    let send_msg_res    = await ConsultationController.sendCareConsultationMessage(message_data);
    let is_success      = send_msg_res && send_msg_res.success ? true : false;
    let send_error      = is_success ? '' : this.get_send_error_text(send_msg_res);

    if (is_success) {
      this.get_care_consultation_messages(consultation_id);
    } else {
      this.refresh_consultation_after_failed_send();
    }

    this.setState({ loading_attachment_button: false, file: null, to_upload: null, attachment_type: '', pdf_name: '', send_error: send_error });
  }

  get_care_consultation_messages = async (care_consultation_id) => {
    let messages_res  = await ConsultationController.getConsultationChatMessages(care_consultation_id);
    let messages      = messages_res && messages_res.success && messages_res.data && messages_res.data.messages ? messages_res.data.messages : [];
        messages.reverse();
    this.setState({ messages: messages });
  }

  get_appended_messages = () => {
    let date_today = new Date();
    let date_str   = date_today.toString();

    let messages          = this.state.messages || [];
    let care_consultation = this.props.care_consultation;
    let profile_pic       = care_consultation && care_consultation.provider && care_consultation.provider.photo_url ? care_consultation.provider.photo_url : '';
    let provider_bio      = care_consultation && care_consultation.provider && care_consultation.provider.bio       ? care_consultation.provider.bio : '';
    let is_async          = care_consultation && care_consultation.is_async && care_consultation.is_async === true  ? true : false;
    let partner           = care_consultation && care_consultation.partner  ?  care_consultation.partner : {};
    let welcome_messages  = partner && partner.welcome_messages ? partner.welcome_messages : [];
    let full_messages     = [];

    if (care_consultation && care_consultation._id && messages && messages.length < 3) {
      let async_welcome_1 = 'Thanks for reaching out! We are busy helping other pet parents at the moment. Please keep this window open and we’ll be back in a few moments to help!'
      let async_welcome_2 = 'If you’re receiving this during business hours, our representatives are busy helping other clients but will be with you shortly.'
      let online_welcome  = "Welcome! We’re looking forward to chatting with you. We will be with you momentarily. In the meantime, feel free to add a brief summary of your questions/concerns today or any additional information, photos or videos you feel is important.";

      let first_message = {
        consultation_id: care_consultation._id,
        content: {text: is_async ? async_welcome_1 : online_welcome },
        from: 'system',
        type: "TEXT",
        created_at: care_consultation.created_at,
        updated_at: care_consultation.created_at,
      }

      let second_message = {
        consultation_id: care_consultation._id,
        content: {text: async_welcome_2 },
        from: 'system',
        type: "TEXT",
        created_at: care_consultation.created_at,
        updated_at: care_consultation.created_at,
      }

      let first_message_arr = is_async ? [first_message] : [first_message];

      if (welcome_messages && welcome_messages.length > 0 && !is_async) {
        let custom_welcome_messages = welcome_messages.map((message_text) => {
          return {
            consultation_id: care_consultation._id,
            content: {text: message_text },
            from: 'system',
            type: "TEXT",
            created_at: care_consultation.created_at,
            updated_at: care_consultation.created_at,
          }
        })
        first_message_arr = [ ...custom_welcome_messages ]
      }

      if (provider_bio) {
        let pic_message_arr = [];

        if (profile_pic) {
          let pic_message = {
            consultation_id: care_consultation._id,
            content: {url: profile_pic },
            from: 'system',
            type: "IMAGE",
            created_at: care_consultation.created_at,
            updated_at: care_consultation.created_at,
          }

          pic_message_arr = [ pic_message ];
        }

        let bio_message = {
          consultation_id: care_consultation._id,
          content: {text: provider_bio },
          from: 'system',
          type: "TEXT",
          created_at: care_consultation.created_at,
          updated_at: care_consultation.created_at,
        }

        let bio_message_arr = [ bio_message ];

        if (is_async) {
          first_message_arr = [ ...first_message_arr, ...bio_message_arr, ...pic_message_arr ];
        } else {
          first_message_arr = [ ...first_message_arr, ...bio_message_arr, ...pic_message_arr ];
        }
      }

      full_messages = [ ...messages, ...first_message_arr ];
    } else {
      full_messages = [ ...messages ];
    }

    return full_messages;
  }

  toggle_chat_bubble = (bubble_data) => {
    let typer_id        = bubble_data.typer_id;
    let consultation_id = bubble_data.consultation_id;
    let current_user_id = getItem('user_id');
    let bubble_seconds  = this.state.bubble_seconds;
    let display_bubble  = this.state.display_type_bubble;

    if (typer_id && current_user_id !== typer_id) {
      bubble_seconds  = 4;
      display_bubble = true;
    }

    this.setState({ ...this.state, display_type_bubble: display_bubble, bubble_seconds: bubble_seconds })
  }

  _onEverySecond = () => {
    let time_elapsed   = this.state.time_elapsed;
        time_elapsed   = time_elapsed + 1;

    let bubble_seconds = this.state.bubble_seconds;
        bubble_seconds = bubble_seconds > 0 ? bubble_seconds - 1 : bubble_seconds;

    let display_bubble = false;
    let every_fifteen  = time_elapsed % 15 === 0;

    if (bubble_seconds > 0) {
      display_bubble = true;
    }

    if (every_fifteen) {
      this.force_pull_messages();
    }

    this.setState({ ...this.state, time_elapsed: time_elapsed, bubble_seconds: bubble_seconds, display_type_bubble: display_bubble });
  }

  force_pull_messages = () => {
    let current_messages = this.state.messages;
    let last_message     = current_messages && current_messages.length > 0 && current_messages[0] ? current_messages[0] : {};
    let sender_id        = last_message && last_message.from ? last_message.from : '';
    let user_id          = getItem('user_id');

    if (sender_id === user_id) {
      let care_consultation_id = getItem('care_consultation_id');
      this.get_care_consultation_messages(care_consultation_id);
    }
  }
}
